import { useState, useEffect } from 'react';
import { Button } from '@nazka/nazka.mapframe.components';
import { faPlus, faMinus } from '@fortawesome/pro-regular-svg-icons';

import './map-navigation.css';

function MapNavigation({ map }) {
  const [bearing, setBearing] = useState(0);

  useEffect(() => {
    if (!map) return;

    const updateBearing = () => {
      setBearing(Math.round(map.getBearing()));
    };

    updateBearing();

    map.on('rotate', updateBearing);

    return () => {
      map.off('rotate', updateBearing);
    };
  }, [map]);

  const handleZoomIn = () => {
    map.zoomIn();
  };

  const handleZoomOut = () => {
    map.zoomOut();
  };

  const handleResetNorth = () => {
    map.resetNorthPitch();
  };

  return (
    <div className="map-navigation" style={{ '--map-bearing': `${-bearing}deg` }}>
      <Button
        className="map-navigation__zoom-in"
        type="button"
        aria-label="Zoom in"
        onClick={handleZoomIn}
        icon={faPlus}
      />
      <span className="map-navigation__spacer" />
      <Button
        className="map-navigation__zoom-out"
        type="button"
        aria-label="Zoom uit"
        onClick={handleZoomOut}
        icon={faMinus}
      />
      <span className="map-navigation__spacer" />
      <Button
        className="map-navigation__compass"
        type="button"
        aria-label="Reset richting naar het noorden"
        onClick={handleResetNorth}
        icon="./img/icons/compass.svg"
      />
    </div>
  );
}

export default MapNavigation;
